import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
import store from '@/store';
// import { isNumber } from 'lodash'
// 过滤按钮权限
var hasPermission = function hasPermission(userPermission) {
  var roles = store.state.user.roles;
  if (roles.length === 0) {
    return false;
  }
  if (Array.isArray(userPermission)) {
    return userPermission.some(function (p) {
      return roles.includes(p);
    });
  }
  return roles.includes(userPermission);
};

// 定义 moneyFormatFunc 函数
/*
{
  label: '回款金额',
  prop: 'money',
  formatter: (row, _, cellValue) => {
    return moneyFormatFunc(cellValue) // 直接调用函数
  }
},

  // if (!isNumber(val)) return val
  // if (val === 0) return '0.00'
  // if (val === '' || val == null || val === '-') return val
  // return Number(val).toLocaleString('zh-CN', { minimumFractionDigits: 2 })
*/

export var isNUmber = function isNUmber(val) {
  return /^-?\d+(\.\d+)?$/.test(val);
};
export var moneyFormatFunc = function moneyFormatFunc(val) {
  if (isNUmber(val)) {
    return Number(val).toLocaleString('zh-CN', {
      minimumFractionDigits: 2
    });
  } else {
    if (val === '' || val == null || val === '-') {
      return val;
    } else if (val.includes('万')) {
      return Number(val.replace('万', '')).toLocaleString('zh-CN', {
        minimumFractionDigits: 2
      }) + '万';
    } else {
      return val;
    }
  }
};
// 千分位 不要小数点
export var noThousandFormatFunc = function noThousandFormatFunc(val) {
  if (isNUmber(val)) {
    return Number(val).toLocaleString('zh-CN', {
      maximumFractionDigits: 0
    });
  } else {
    if (val === '' || val == null || val === '-') {
      return val;
    } else if (val.includes('万')) {
      return Number(val.replace('万', '')).toLocaleString('zh-CN', {
        maximumFractionDigits: 0
      }) + '万';
    } else {
      return val;
    }
  }
};

// 注册为过滤器
Vue.filter('moneyFormat', moneyFormatFunc);
Vue.prototype.$moneyFormat = moneyFormatFunc;
Vue.filter('noThousandFormatFunc', noThousandFormatFunc);
Vue.prototype.$noThousandFormatFunc = noThousandFormatFunc;
Vue.prototype.$hasBtnRoles = hasPermission;